import { Box, Typography } from '@mui/material';
import { AuthErrorProps } from './AuthError.types';
import './AuthError.css';

export const AuthError = ({ message }: AuthErrorProps) => {
  return (
    <Box className="auth-error-container">
      <Box className="auth-error-card">
        <Typography variant="h5" className="auth-error-title">
          Failed to authenticate user
        </Typography>
        <Typography className="auth-error-message">{message}</Typography>
      </Box>
    </Box>
  );
};
